import styled from 'styled-components'

export const Styled = {
  Wrapper: styled.div`
    position: relative;
  `,
  Current: styled.div`
    text-transform: uppercase;
    font-weight: bold;
    font-size: 21px;
    color: #eda211;
    display: flex;
    align-items: center;

    svg {
      display: none;
    }

    &.has-options {
      cursor: pointer;
      svg {
        display: block;
      }
    }
  `,
  Dropdown: styled.div`
    position: absolute;
    z-index: 10000;
    top: 100%;
    right: 0;
    margin-top: 8px;
    border-radius: 12px;
    max-height: 200px;
    overflow-y: auto;
    overflow-x: hidden;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(20px);
    box-shadow:
      0 8px 32px rgba(0, 0, 0, 0.12),
      0 2px 8px rgba(0, 0, 0, 0.08),
      inset 0 1px 0 rgba(255, 255, 255, 0.1);
    min-width: 200px;

    &.left {
      right: auto;
      left: 0;
    }

    &.right {
      left: auto;
      right: 0;
    }
  `,
  DropdownItem: styled.div`
    cursor: pointer;
    font-size: 16px;
    font-weight: 500;
    text-transform: uppercase;
    padding: 12px 16px;
    transition: all 0.3s ease;
    color: rgba(255, 255, 255, 0.9);
    border-bottom: 1px solid rgba(255, 255, 255, 0.05);
    position: relative;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      color: #eda211;
      background: rgba(255, 255, 255, 0.08);
    }

    &:first-child {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
    }

    &:last-child {
      border-bottom-left-radius: 12px;
      border-bottom-right-radius: 12px;
    }
  `,
}
